import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { fetchChatAttachmentImage } from "web_myplann/Api/Chat/fetchChatAttachmentImage";
import { useObjectUrl } from "web_myplann/Shared/Hooks/useObjectUrl";
import { sessionState } from "web_myplann/Shared/State/sessionAtom";

const ATTACHMENT_IMAGE_GC_TIME = 10 * 60 * 1000;

export const useChatAttachmentImage = (
	attachmentId: number | undefined,
	enabled: boolean,
) => {
	const session = useAtomValue(sessionState);

	const { data: blob, isLoading } = useQuery({
		queryKey: ChatKeys.attachmentImage(attachmentId),
		queryFn: () => fetchChatAttachmentImage(attachmentId!, session),
		enabled: enabled && attachmentId !== undefined,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: ATTACHMENT_IMAGE_GC_TIME,
		meta: { persist: false },
	});

	return { url: useObjectUrl(blob), isLoading };
};
